const ENV_VARS_KEY = 'env_vars'
const RIGHT_STORAGE_KEY = 'right_storage_key'
const RIGHT_INFO_KEY = 'right_info_key'

export const getEnvVarsFromStorage = () => {
  const env_vars = localStorage.getItem(ENV_VARS_KEY)
  return env_vars === null ? null : JSON.parse(env_vars)
}
export const setEnvVarsToStorage = (data) => {
  localStorage.setItem(ENV_VARS_KEY, data === null ? null : JSON.stringify(data))
}

export const getUserRightsFromStorage = () => {
  const user_rights = localStorage.getItem(RIGHT_STORAGE_KEY)
  return user_rights === null ? null : JSON.parse(user_rights)
}
export const setUserRightsToStorage = (data) => {
  localStorage.setItem(RIGHT_STORAGE_KEY, data === null ? null : JSON.stringify(data))
}
export const getUserInfosFromStorage = () => {
  const user_infos = localStorage.getItem(RIGHT_INFO_KEY)
  return user_infos === null ? null : JSON.parse(user_infos)
}
export const setUserInfosToStorage = (data) => {
  localStorage.setItem(RIGHT_INFO_KEY, data === null ? null : JSON.stringify(data))
}
// export const removeUserRightsFromStorage = () => {
//   localStorage.removeItem(RIGHT_STORAGE_KEY)
// }
export const clearStorage = () => {
  localStorage.clear()
}
